import { useContext } from 'react';

import { HotelImagesContext } from '../contexts/HotelImagesContext';

import type { HotelImagesStore } from '../types/hotel-images';

export const useHotelImagesContext = () => {
  const { actions, state } = useContext(HotelImagesContext);
  return { ...state, ...actions } as HotelImagesStore;
};

export const useAllImages = () => {
  const { state } = useContext(HotelImagesContext);

  const hotelImages = state?.images?.hotel.items ?? [];
  const travelerImages = state?.images?.traveller.items ?? [];

  return {
    allImages: [...hotelImages, ...travelerImages],
    imagesCount: state?.imageCount,
  };
};

export const useReviewImages = () => {
  const { state } = useContext(HotelImagesContext);

  return state?.images?.traveller.items;
};
